import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { postRequest as post } from '../utils/HttpMethods';
import { useNotification } from '@refinedev/core';

export interface ResendPasswordResponse {
  success: boolean;
  action?: 'invite_resend' | 'password_reset';
  userStatus?: string;
  delivery?: 'EMAIL';
}

const resendUserPassword = async (
  email: string
): Promise<ResendPasswordResponse> => {
  const resend: ResendPasswordResponse = await post(
    'QBilling',
    '/action/user/password/resend',
    {
      email,
    }
  );

  try {
    if (resend) {
      return { success: true };
    } else {
      throw new Error('Failed To Resend Password');
    }
  } catch (error) {
    throw new Error('Failed To Resend Password');
  }
};

export const useResendUserPassword =
  (): UseMutationResult<ResendPasswordResponse> => {
    const { open } = useNotification();
    return useMutation({
      mutationFn: resendUserPassword,
      onError: (error) => {
        open({
          message: 'Error Sending Access Reset',
          description: error.message,
          type: 'error',
        });
      },
      onSuccess: (data) => {
        const message = 'Sent';
        const description =
          data.action === 'invite_resend'
            ? 'Welcome email with a new temporary password has been sent.'
            : 'Password reset email has been sent.';
        open({
          message,
          description,
          type: 'success',
        });
      },
    });
  };
